import { lazy } from 'react';

/**
 * The activity trail, at /activites.
 *
 * Routed but never linked. Nothing in the navigation points here and nothing
 * should: the page is for the owner, reached by typing the address. The spelling
 * is the one that was asked for and is what anybody will type from memory.
 */
const ActivitiesRoutes = [
  {
    path: 'activites',
    component: lazy(() => import('views/activities')),
  },
  /* The English spelling too, so a reasonable guess is not a dead end. */
  {
    path: 'activities',
    component: lazy(() => import('views/activities')),
  },
];

export default ActivitiesRoutes;
